var data = {
  "body": "<path d=\"M0 146.484v168.677l600 342.114l600-342.114V146.484H0zm0 276.563v494.604L305.64 597.29L0 423.047zm1200 0L894.36 597.29L1200 917.651V423.047zM389.575 645.19L0 1053.516h1200L810.425 645.19L600 765.161L389.575 645.19z\" fill=\"currentColor\"/>",
  "width": 1200,
  "height": 1200
};
export default data;